"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SecureDocumentsProvider: true
};
Object.defineProperty(exports, "SecureDocumentsProvider", {
  enumerable: true,
  get: function get() {
    return _SecureDocumentsProvider.default;
  }
});

var _SecureDocumentsProvider = _interopRequireWildcard(require("./SecureDocumentsProvider"));

Object.keys(_SecureDocumentsProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SecureDocumentsProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SecureDocumentsProvider[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIgfSBmcm9tICcuL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyJztcbmV4cG9ydCAqIGZyb20gJy4vU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXInO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/context/index.js
// module id = 115
// module chunks = 0